import { render, staticRenderFns } from "./projectRecord.vue?vue&type=template&id=2b25154e&scoped=true&"
import script from "./projectRecord.vue?vue&type=script&lang=js&"
export * from "./projectRecord.vue?vue&type=script&lang=js&"
import style0 from "./projectRecord.vue?vue&type=style&index=0&id=2b25154e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b25154e",
  null
  
)

export default component.exports